import React from "react";
import LoadingIcon from "./loader";

const LoadingMessage = ({ height, absolutePosition = true }) => (
  <div
    id="loadingMessage"
    style={{
      position: absolutePosition ? "absolute" : "relative",
      width: "100%",
      height: height || "100%",
      backgroundColor: "#ebebeb",
      textAlign: "center",
      zIndex: 10
    }}
  >
    <div>
      <LoadingIcon />
    </div>
  </div>
);

export default LoadingMessage;
